/*
 * @Author: Chao Yang
 * @Date: 2019-12-11 10:02:35
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-12 08:31:16
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as Document from 'src/app/domain/model/document';
import * as Fund from 'src/app/domain/model/fund';
import * as Offering from 'src/app/domain/model/offering';
import { FundProxy, OfferingProxy } from 'src/app/domain/proxy';
import { SessionService } from '../session';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class FundService {
  constructor(
    private _fundProxy: FundProxy,
    private _offeringProxy: OfferingProxy,
    private _sessionService: SessionService
  ) {}

  getFunds(
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFund[]> {
    return this._fundProxy.getFunds(accounts).pipe(
      map((funds) => {
        funds.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        return funds;
      })
    );
  }

  getFundsAll(
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IFund[]> {
    return this._fundProxy.getFundsAll(accounts).pipe(
      map((funds) => {
        funds.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        return funds;
      })
    );
  }

  getFundSummary(fundId: number): Observable<Offering.OfferingDetailSummary> {
    return this._offeringProxy.getOfferingDetailSummary(fundId);
  }

  getOfferings(type: number): Observable<Fund.IFund[]> {
    return this._fundProxy.getOfferings(type);
  }

  read(fundId: number): Observable<void> {
    if (this._sessionService.isShadow()) {
      return this._fundProxy.getShadowUserDefaultObservable();
    }
    return this._fundProxy.read(fundId);
  }

  interesetedInFund(fundId: number) {
    return this._fundProxy.interesetedInFund(fundId);
  }

  getFundDescription(fundId: number) {
    return this._fundProxy.getFundDescription(fundId);
  }
}
